<template>
  <div class="leads-listing">
    <collection
      @sorting="sorting"
      @itemDelete="itemDelete"
      :loading="loading"
      :data="data"
      :structure="structure"
      :params="params"
      model="project_lead"
      :has_searched="has_searched"
    ></collection>
  </div>
</template>
<script>
import Collection from "@/components/helpers/DataDisplay/Collection";
import CrmStatus from "@/components/helpers/DataDisplay/CollectionValues/CollectionValueCrmStatus";
import DeleteAction from "@/components/helpers/DataDisplay/CollectionValues/CollectionValueCrudActionFolded";
import ProgressBar from "@/components/helpers/DataDisplay/ProgressBar";

export default {
  components: { Collection, CrmStatus, DeleteAction, ProgressBar },
  props: ["loading", "data", "structure", "id", "params", "has_searched"],
  methods: {
    sorting(payload) {
      this.$emit("sorting", payload);
    },
    itemDelete(payload) {
      this.$emit("itemDelete", payload);
    },
    date(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  },
  computed: {
    crmStatusColumn() {
      return _.find(this.structure, { name: "sync_status" });
    },
    progressColumn() {
      return _.find(this.structure, { name: "sync_status" });
    },
    actionDeleteColumn() {
      return _.find(this.structure, { name: "action" });
    }
  }
};
</script>
<style lang="scss">
.leads-listing--desktop {
  @include respond-to("small") {
    display: none;
  }
}
.leads-listing--mobile {
  @include respond-to("medium-up") {
    display: none;
  }

  .lead {
    border-left: 11px solid transparent;
    position: relative;
    display: block;

    &.lead-cold {
      border-left-color: $lead-cold;
    }
    &.lead-warm {
      border-left-color: $lead-warm;
    }
    &.lead-hot {
      border-left-color: $lead-hot;
    }
    .grid {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    margin-left: -1em;
    margin-right: -1em;
    margin-top: 5px;
    margin-bottom: 15px;
    padding: 1em;
    &:after {
      content: "";
      display: block;
      height: 1px;
      background: #f2f2f2;
      position: absolute;
      bottom: -8px;
      left: 0;
      right: 0;
    }
  }

  .lead--progress,
  .lead--name,
  .lead--company {
    flex-grow: 5;
  }
  .lead--name {
    font-weight: 400;
    font-size: 1.1em;
    text-decoration: none;
  }
  .lead--start_date {
    opacity: 0.38;
  }
  .lead--delete {
    height: 24px;
    margin-left: 20px;
  }
  .dot-navigation--trigger {
    padding: 0;
  }
  .progress-bar {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// LeadsListing.vue?4e43add9